import {
    type NativeSelectWebOptionStyleConstantType,
    type NativeSelectWebStyleConstantType,
    type NativeSelectWebStyle
} from "./type";

export const NATIVE_SELECT_WEB_RESET: NativeSelectWebStyle = {
    background: "transparent",
    WebkitAppearance: "none",
    textOverflow: "ellipsis",
    alignSelf: "stretch",
    appearance: "none",
    outline: "none",
    border: "none",
    minWidth: 0,
    opacity: 1,
    margin: 0,
    flex: 1
};

export const NATIVE_SELECT_WEB_ICON_STYLE = {
    pointerEvents: "none"
} as const;

export const getNativeSelectWebStyle = ({
    placeholderColor,
    isPlaceholder,
    currentSize,
    isDisabled,
    typography,
    valueColor,
    colors,
    spaces
}: NativeSelectWebStyleConstantType): NativeSelectWebStyle => {
    const typographyRole = typography[currentSize.valueVariant];

    const endInset = currentSize.paddingHorizontal + currentSize.iconSize + spaces.spacingSm;

    return {
        ...NATIVE_SELECT_WEB_RESET,
        color: isPlaceholder ? placeholderColor : valueColor ?? colors.content.text.high,
        marginInlineStart: -currentSize.paddingHorizontal,
        paddingInlineStart: currentSize.paddingHorizontal,
        cursor: isDisabled ? "not-allowed" : "pointer",
        letterSpacing: typographyRole.letterSpacing,
        fontFamily: typographyRole.fontFamily,
        fontWeight: typographyRole.fontWeight,
        fontSize: typographyRole.fontSize,
        marginInlineEnd: -endInset,
        paddingInlineEnd: endInset
    };
};

export const getNativeSelectWebOptionStyle = ({
    colors
}: NativeSelectWebOptionStyleConstantType): NativeSelectWebStyle => {
    return {
        backgroundColor: colors.content.container.raised,
        color: colors.content.text.high
    };
};
